import React from 'react'
import { Link } from 'react-router-dom'
import loading_picture from '../../img/user.jpg'
import FollowButton from './FollowButton'
/* REDUX */
import { connect } from 'react-redux'
import { formatDate } from '../../utility/Formatter'

class AuthorProfile extends React.Component {
	render() {
		
		const { _id, username, profile_picture, name, created, onLogin } = this.props
		
		let formattedDate = formatDate(created)
		
		let user_img = profile_picture && profile_picture != 'undefined' ?  profile_picture : 'https://firebasestorage.googleapis.com/v0/b/theflightpost.appspot.com/o/users%2F5976702cffb33336cf827d95.jpg?alt=media&token=32da20ee-1450-44b5-ad37-04b317d18f04'
		
		if (!_id || !username || !name || !formattedDate ) {
			return (
				<div className="author-profile">
					<div className="left">
						<Link to={'/profile/' + username}>
							<img src={ loading_picture } />
						</Link>
					</div>
					<div className="right">
						<div className="bio">
							<span className="loading-bar w-100px mb-2"></span>
							<span className="loading-bar w-50px"></span>
						</div>
						<button type="button" className="btn btn-follow">Follow</button>
					</div>
				</div>
			)
		}
		
		return (
			<div className="author-profile">
				<div className="left">
					<Link to={'/profile/' + username}>
						<img src={ user_img } />
					</Link>
				</div>
				<div className="right">
					<div className="bio">
						<Link to={'/profile/' + username}>
							<span className="name">{ name }</span>
						</Link>
						<span className="date">{ formattedDate }</span>
					</div>
					<FollowButton author_id={ username } onLogin={ onLogin } />
				</div>
			</div>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.params.report_id
	const { reportById } = state
	const { report } = reportById[report_id]
	const { _user, created } = report
	const { _id, profile_picture, username, name } = _user || {}
	return {
		_id,
		username,
		profile_picture,
		name,
		created,
		authenticated: state.auth.authenticated,
		user_id: state.auth.user_id
	}
}

export default connect(mapStateToProps)(AuthorProfile)


// WEBPACK FOOTER //
// ./src/components/Report/AuthorProfile.js